import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";
import configure from "configure";
// assets
import "../../../../assets/css/Sales/Sales.css";

// tabId: which verticalActiveTab value means "this tab is active" in the
// parent's own numbering scheme -- View Lead (index.js) and Edit Lead use
// different tab layouts, so this can't be hardcoded.
const ViewContracts = ({ leadId, verticalActiveTab, tabId = "7" }) => {
    const navigate = useNavigate();
    const [contract, setContract] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchContracts = async () => {
        if (!leadId) return;
        setLoading(true);
        try {
            const token = secureLocalStorage.getItem("auth_token");
            const res = await axios.get(
                `${configure.nodeApi}/get_contract_by_lead/${leadId}`,
                { headers: { Accept: "application/json", Authorization: `Bearer ${token}` } },
            );
            setContract(res?.data?.data || null);
        } catch (err) {
            console.log(err);
            setContract(null);
        }
        setLoading(false);
    };

    useEffect(() => {
        if (verticalActiveTab === tabId) fetchContracts();
    }, [verticalActiveTab, tabId, leadId]);

    const onDelete = (id) => {
        swal({
            title: "Are you sure?",
            text: "You want to Delete this Contract !",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (!willDelete) return;
            const formData = new FormData();
            formData.append("user_id", localStorage.getItem("auth_id"));
            formData.append("contract_id", id);
            try {
                await axios({
                    method: "post",
                    url: `${configure.nodeApi}/delete_contract`,
                    data: formData,
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",
                    },
                });
                swal({ icon: "success", text: "Contract Deleted Successfully" }).then(
                    () => fetchContracts(),
                );
            } catch (err) {
                console.log(err);
                swal({ icon: "error", text: "Something went wrong" });
            }
        });
    };

    return (
        <React.Fragment>
            <div className="mb-3">
                <Row>
                    <Col lg="12">
                        <Card>
                            <CardBody>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <CardTitle className="mb-0">Contracts</CardTitle>
                                    {!contract && (
                                        <a
                                            href={`${configure.appUrl}sales/add-contract?related=lead&source_id=${leadId}`}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="btn btn-sm btn-purple"
                                        >
                                            <i className="fas fa-plus me-1"></i>
                                            New Contract
                                        </a>
                                    )}
                                </div>
                                <div className="responsive-table table-responsive">
                                    <table className="table table-bordered mb-0 table-striped table-hover">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Service</th>
                                                <th>Value</th>
                                                <th>Duration</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!contract ? (
                                                <tr>
                                                    <td className="text-center" colSpan={5}>
                                                        {loading ? "Loading..." : "No Contracts Available"}
                                                    </td>
                                                </tr>
                                            ) : (
                                                <tr>
                                                    <td>{contract?.service || "-"}</td>
                                                    <td>{contract?.value || "-"}</td>
                                                    <td>
                                                        {contract?.startdate
                                                            ? moment(contract.startdate).format("DD-MM-YYYY")
                                                            : "-"}{" "}
                                                        -{" "}
                                                        {contract?.enddate
                                                            ? moment(contract.enddate).format("DD-MM-YYYY")
                                                            : "-"}
                                                    </td>
                                                    <td>
                                                        {contract?.approve == 1
                                                            ? "Approved"
                                                            : "Pending Approval"}
                                                    </td>
                                                    <td>
                                                        <div className="d-flex">
                                                            <Link
                                                                to={`${configure.appUrl}sales/view-contract/${contract.id}`}
                                                                title="View Contract"
                                                                className="btn btn-sm btn-outline-secondary me-1"
                                                            >
                                                                <i className="fas fa-eye"></i>
                                                            </Link>
                                                            <a
                                                                onClick={() =>
                                                                    navigate(
                                                                        `${configure.appUrl}sales/edit-contract/${contract.id}`,
                                                                    )
                                                                }
                                                                title="Edit Contract"
                                                                className="btn btn-sm btn-outline-secondary me-1"
                                                            >
                                                                <i className="fas fa-pencil-alt"></i>
                                                            </a>
                                                            <a
                                                                onClick={() => onDelete(contract.id)}
                                                                title="Delete Contract"
                                                                className="btn btn-sm btn-outline-secondary"
                                                            >
                                                                <i className="fas fa-trash-alt text-danger"></i>
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    );
};

export default ViewContracts;
